"use strict";

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var bip39_1 = require("bip39");

var cryptoRandom_1 = require("./cryptoRandom");

var sha2Hash_1 = require("./sha2Hash");

var hmacSha256_1 = require("./hmacSha256");

var aesCipher_1 = require("./aesCipher");

var pbkdf2_1 = require("./pbkdf2");
/**
 * Encrypt a raw mnemonic phrase to be password protected
 * @param {string} phrase - Raw mnemonic phrase
 * @param {string} password - Password to encrypt mnemonic with
 * @return {Promise<Buffer>} The encrypted phrase
 * @private
 * @ignore
 * */


function encryptMnemonic(phrase, password, opts) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var mnemonicEntropy, plaintextNormalized, pbkdf2, salt, keysAndIV, encKey, macKey, iv, cipher, cipherText, hmacPayload, hmacSha256, hmacDigest, payload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // must be bip39 mnemonic
            mnemonicEntropy = bip39_1.mnemonicToEntropy(phrase);
            _context.next = 9;
            break;

          case 4:
            _context.prev = 4;
            _context.t0 = _context["catch"](0);
            console.error('Invalid mnemonic phrase provided');
            console.error(_context.t0);
            throw new Error('Not a valid bip39 mnemonic');

          case 9:
            // normalize plaintext to fixed length byte string
            plaintextNormalized = Buffer.from(mnemonicEntropy, 'hex'); // AES-128-CBC with SHA256 HMAC

            _context.next = 12;
            return pbkdf2_1.createPbkdf2();

          case 12:
            pbkdf2 = _context.sent;

            if (opts && opts.getRandomBytes) {
              salt = opts.getRandomBytes(16);
            } else {
              salt = cryptoRandom_1.randomBytes(16);
            }

            _context.next = 16;
            return pbkdf2.derive(password, salt, 100000, 48, 'sha512');

          case 16:
            keysAndIV = _context.sent;
            encKey = keysAndIV.slice(0, 16);
            macKey = keysAndIV.slice(16, 32);
            iv = keysAndIV.slice(32, 48);
            _context.next = 22;
            return aesCipher_1.createCipher();

          case 22:
            cipher = _context.sent;
            _context.next = 25;
            return cipher.encrypt('aes-128-cbc', encKey, iv, plaintextNormalized);

          case 25:
            cipherText = _context.sent;
            hmacPayload = Buffer.concat([salt, cipherText]);
            _context.next = 29;
            return hmacSha256_1.createHmacSha256();

          case 29:
            hmacSha256 = _context.sent;
            _context.next = 32;
            return hmacSha256.digest(macKey, hmacPayload);

          case 32:
            hmacDigest = _context.sent;
            payload = Buffer.concat([salt, hmacDigest, cipherText]);
            return _context.abrupt("return", payload);

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 4]]);
  }));
}

exports.encryptMnemonic = encryptMnemonic; // Used to distinguish bad password during decrypt vs invalid format

var PasswordError =
/*#__PURE__*/
function (_Error) {
  _inherits(PasswordError, _Error);

  function PasswordError() {
    _classCallCheck(this, PasswordError);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasswordError).apply(this, arguments));
  }

  return PasswordError;
}(_wrapNativeSuper(Error));
/**
 * @ignore
 */


function decryptMnemonicBuffer(dataBuffer, password) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var salt, hmacSig, cipherText, hmacPayload, pbkdf2, keysAndIV, encKey, macKey, iv, decipher, decryptedResult, hmacSha256, hmacDigest, sha2Hash, hmacSigHash, hmacDigestHash, mnemonic;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            salt = dataBuffer.slice(0, 16);
            hmacSig = dataBuffer.slice(16, 48); // 32 bytes

            cipherText = dataBuffer.slice(48);
            hmacPayload = Buffer.concat([salt, cipherText]);
            _context2.next = 6;
            return pbkdf2_1.createPbkdf2();

          case 6:
            pbkdf2 = _context2.sent;
            _context2.next = 9;
            return pbkdf2.derive(password, salt, 100000, 48, 'sha512');

          case 9:
            keysAndIV = _context2.sent;
            encKey = keysAndIV.slice(0, 16);
            macKey = keysAndIV.slice(16, 32);
            iv = keysAndIV.slice(32, 48);
            _context2.next = 15;
            return aesCipher_1.createCipher();

          case 15:
            decipher = _context2.sent;
            _context2.next = 18;
            return decipher.decrypt('aes-128-cbc', encKey, iv, cipherText);

          case 18:
            decryptedResult = _context2.sent;
            _context2.next = 21;
            return hmacSha256_1.createHmacSha256();

          case 21:
            hmacSha256 = _context2.sent;
            _context2.next = 24;
            return hmacSha256.digest(macKey, hmacPayload);

          case 24:
            hmacDigest = _context2.sent;
            _context2.next = 27;
            return sha2Hash_1.createSha2Hash();

          case 27:
            sha2Hash = _context2.sent;
            _context2.next = 30;
            return sha2Hash.digest(hmacSig);

          case 30:
            hmacSigHash = _context2.sent;
            _context2.next = 33;
            return sha2Hash.digest(hmacDigest);

          case 33:
            hmacDigestHash = _context2.sent;

            if (hmacSigHash.equals(hmacDigestHash)) {
              _context2.next = 36;
              break;
            }

            throw new PasswordError('Wrong password (HMAC mismatch)');

          case 36:
            _context2.prev = 36;
            mnemonic = bip39_1.entropyToMnemonic(decryptedResult);
            _context2.next = 45;
            break;

          case 40:
            _context2.prev = 40;
            _context2.t0 = _context2["catch"](36);
            console.error('Error thrown by `entropyToMnemonic`');
            console.error(_context2.t0);
            throw new PasswordError('Wrong password (invalid plaintext)');

          case 45:
            if (bip39_1.validateMnemonic(mnemonic)) {
              _context2.next = 47;
              break;
            }

            throw new PasswordError('Wrong password (invalid plaintext)');

          case 47:
            return _context2.abrupt("return", mnemonic);

          case 48:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[36, 40]]);
  }));
}
/**
 * Decrypt legacy triplesec keys
 * @param {Buffer} dataBuffer - The encrypted key
 * @param {String} password - Password for data
 * @return {Promise<Buffer>} Decrypted seed
 * @private
 * @ignore
 */


function decryptLegacy(dataBuffer, password, triplesecDecrypt) {
  return new Promise(function (resolve, reject) {
    if (!triplesecDecrypt) {
      reject(new Error('The `triplesec.decrypt` function must be provided'));
    }

    triplesecDecrypt({
      key: Buffer.from(password),
      data: dataBuffer
    }, function (err, plaintextBuffer) {
      if (!err) {
        resolve(plaintextBuffer);
      } else {
        reject(err);
      }
    });
  });
}
/**
 * Decrypt an encrypted mnemonic phrase with a password.
 * Legacy triplesec encrypted payloads are also supported.
 * @param data - Buffer or hex-encoded string of the encrypted mnemonic
 * @param password - Password for data
 * @return the raw mnemonic phrase
 * @private
 * @ignore
 */


function decryptMnemonic(data, password, triplesecDecrypt) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var dataBuffer, _data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dataBuffer = Buffer.isBuffer(data) ? data : Buffer.from(data, 'hex');
            _context3.prev = 1;
            _context3.next = 4;
            return decryptMnemonicBuffer(dataBuffer, password);

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](1);

            if (!(_context3.t0 instanceof PasswordError)) {
              _context3.next = 11;
              break;
            }

            throw _context3.t0;

          case 11:
            _context3.next = 13;
            return decryptLegacy(dataBuffer, password, triplesecDecrypt);

          case 13:
            _data = _context3.sent;
            return _context3.abrupt("return", _data.toString());

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 7]]);
  }));
}

exports.decryptMnemonic = decryptMnemonic;